import React from 'react'
import image from '../../Images/cobon.png';
import styles from './Home.module.css'
import { useTranslation } from "react-i18next";
import homePageImage from "../../Images/homePageImage.png"
import { useSelector } from 'react-redux';

 function Head({branchId}) {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language; // Get current selected language
    const {oneUser} = useSelector((state) => state.usersSlice);
    let units = 0
    if(oneUser?.cln_units != null){
      units = Number(oneUser?.cln_units?.trim()).toFixed(2)
    }
  return (
    <div className={styles.headComponant} style={{width:"100%",  backgroundImage: `url(${homePageImage})`, backgroundSize: "cover", backgroundRepeat: "no-repeat",  backgroundPosition: "center",}}>
      <div  className={styles.cobonImageContainer}>
          <div className={styles.cobonLabel}>
            <span>
         { branchId == 3 ? "Man Care Membership" :  branchId == 2 ? "Lady Care Membership" : "Care Membership" }
            </span>
            <span className={styles.cobonLabel2} style={{color:"#3D3D3D"}}>
              <span style={{margin:"0 8px"}}>{t('Loyal Points')} </span>
              <span>{units} </span>
              <span> {t('point')}</span>
            </span>
            {/* <div className={styles.cobonCode}>نسخ الكود</div> */}
          </div>
         

  
      </div>

    </div>
  )
}
export default Head;
